import PropTypes from "prop-types";
import { Image, Skeleton } from "@react-spectrum/s2";

import { usePresignURL } from "@app/hooks/s3";

export const S3Image = ({ filePath, src, isLoading, ...props }) => {
  const urlQuery = usePresignURL(filePath, { enabled: !src && !!filePath });

  return (
    <Skeleton isLoading={!!isLoading || urlQuery.isFetching}>
      <Image src={urlQuery.data?.presignURL ?? src ?? null} {...props} />
    </Skeleton>
  );
};

S3Image.propTypes = {
  filePath: PropTypes.string.isRequired,
  src: PropTypes.string,
  isLoading: PropTypes.bool,
};
